<template>
    <div class="enterprise-info first">
        <ul class="list">
            <li>
                <span class="color-info">
                    <svg-icon icon-class="enterprise"></svg-icon>
                    企业名称
                </span>
                {{ info.licenceEnterpriseName }}
            </li>
            <li>
                <span class="color-info">
                    <svg-icon icon-class="card"></svg-icon>
                    证件类型
                </span>
                企业营业执照统一社会信用代码（{{ info.licenceNumber }}）
            </li>
            <li>
                <span class="color-info">
                    <svg-icon icon-class="legalPerson"></svg-icon>
                    法人名称
                </span>
                {{ info.licenceLegalPersonName }} {{ info.licenceLegalPersonNumber ? `(${info.licenceLegalPersonNumber})` : '' }}
            </li>
            <li v-if="info.enterpriseUpgradeFlag == 2">
                <span class="color-info">
                    <svg-icon icon-class="legalPerson"></svg-icon>
                    认证人
                </span>
                {{ info.name }}（{{ info.userIdNum }}）
                <span v-if="$store.getters.enterpriseUpgradeType == 2" class="color-warning">（代理人）</span>
                <span v-if="$store.getters.enterpriseUpgradeType == 1 || $store.getters.enterpriseUpgradeType == 3" class="color-warning">
                    （法人）
                </span>
                <!-- <el-button v-if="$store.getters.enterpriseUpgradeType == 2" @click="updateAdminVisible = true" type="text"
                    class="right underline">
                    移交企业管理员
                </el-button> -->
            </li>
            <li>
                <span class="color-info">
                    <svg-icon icon-class="phone"></svg-icon>
                    手机号（登录账号）
                </span>
                {{ info.telephone }}
                <el-button v-if="info.telephone" @click="$contractRouter('/manage/contract/update/fdd/phone')" type="text" class="right underline">
                    修改手机
                </el-button>
            </li>
            <li>
                <span class="color-info">
                    <svg-icon icon-class="relname"></svg-icon>
                    实名认证
                </span>
                <strong v-if="$store.getters.userState > 1" class="color-success">认证成功</strong>

                <template v-else>
                    <strong class="color-base">未实名认证</strong>
                    <router-link :to="$contractRouter('/manage/contract/verify/fdd/step/1', 'url')" class="btn-renewal color-theme">认证</router-link>
                </template>
            </li>
            <li>
                <span class="color-info">
                    <svg-icon icon-class="relname"></svg-icon>
                    合同签署
                </span>
                <strong v-if="$store.getters.goContractSigned == ''" class="color-success">签署成功</strong>

                <template v-else>
                    <strong class="color-base">未签署合同</strong>
                    <el-button @click="$contractRouter($store.getters.goContractSigned)" type="text" class="right underline">签署</el-button>
                </template>
            </li>
            <li>
                <span class="color-info">
                    <svg-icon icon-class="time"></svg-icon>
                    服务有效期
                </span>

                <template v-if="$store.getters.userState >= 5">
                    <i :class="[$store.getters.userState == 5 ? 'red' : '']">{{ info.cpOrgVipVO ? info.cpOrgVipVO.endTimeStr : '' }}</i>
                    {{ $store.getters.userState == 5 ? '已过期' : '到期' }}
                    <el-button v-if="$store.state.userType != 3" @click="$router.push('/manage/pay')" type="text" class="right underline">
                        续费
                    </el-button>
                </template>

                <template v-if="$store.getters.userState == 3 || $store.getters.userState == 4">
                    <strong class="color-base">未支付服务年费</strong>
                    <el-button @click="$router.push('/manage/pay')" type="text" class="right underline">支付</el-button>
                </template>
            </li>
        </ul>
        <!-- 更改企业管理员 -->
        <el-dialog title="移交企业管理员须知" append-to-body :show-close="false" center :visible.sync="updateAdminVisible" width="600px">
            <p class="dialog-tip" style="text-align: left">
                1. 请确保新的管理员已经在秀动发行完成注册并进行了实名认证
                <br />
                2. 发起更新企业管理员后，您将收到一条来自“电子牵”的短信，需要你打开短信的 链接，完成授权书签署
                <br />
                3. 移交企业管理员完成后，
                <span class="color-danger">您手机号将无法登录秀动发行的该企业账号</span>
                。
            </p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateAdminVisible = false" type="info">取消</el-button>
                <el-button type="primary" @click="$router.push('/manage/updateAdmin')">我已知晓，继续更改</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        info: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            visible: false,
            updateAdminVisible: false,
        };
    },
    computed: {},
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
